import {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
    useRef
} from 'react'
import { useAuth, useUser } from '.'
import { useConnectionContext } from './Connection.context'

import { useLocation, useNavigate } from 'react-router-dom'
import addNotification from 'react-push-notification'
import logoNotification from '../assets/logo_icv_notification_push.webp'
import { LinearProgress } from '@mui/material'

import { useSitesContext } from './Sites.context'
import { useAlertContext } from './Alert.context'
import { useLoadingContext } from './Loading.context'
import ReportsService from '../services/reports.service'
import ExecutionReportsService from '../services/execution-reports.service'
import { reportsDatabase, executionReportsDatabase } from '../indexedDB'
import { ReportCommitDialog } from '../dialogs' // Import existing dialog
import BulkFinishShiftDialog from '../dialogs/BulkFinishShiftDialog'
import { useStatus } from './Status.context'

export const ReportsContext = createContext()

export const ReportsProvider = (props) => {
    const location = useLocation()
    const { setLoadingLogo } = useLoadingContext()
    const { setAlertSimple } = useAlertContext()
    const { isOnline } = useConnectionContext()
    const { isAuthenticated, userData, logout } = useAuth()
    const {
        admin,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        site,
        isOperator,
        isSuperAdmin,
        isUniversalInspector,
        isUniversalChief,
        isOperatorInspector,
        isObserver
    } = useUser()
    const { setstatus } = useStatus()
    const [reports, setReports] = useState([])
    const [report, setReport] = useState()
    const [progress, setProgress] = useState(0)
    const [pageProgress, setPageProgress] = useState(0)
    const [itemProgress, setItemProgress] = useState(0)
    const [otIndex, setOtIndex] = useState()
    const { siteSelected, setSiteSelected, sites, sitesToSelection } =
		useSitesContext()
    const [reportsCache, setReportsCache] = useState([])
    const [reportsResume, setReportsResume] = useState([])
    const [assignments, setAssignments] = useState([])
    const [assignmentsError, setAssignmentsError] = useState(null)
    const [listSelected, setListSelected] = useState([])
    const [listSelectedCache, setListSelectedCache] = useState([])
    const [pautas, setPautas] = useState([])
    const [pautasCache, setPautasCache] = useState([])
    const [loading, setLoading] = useState(false)
    const [priorityAssignments, setPriorityAssignments] = useState([])
    const [normalAssignments, setNormalAssignments] = useState([])
    const [message, setMessage] = useState('Descargando reportes')
    const [statusReports, setStatusReports] = useState(false)
    const [revision, setRevision] = useState(true)
    const [reportSelected, setReportSelected] = useState()
    const [reportsProgress, setReportsProgress] = useState()
    const [finishReportsProgress, setFinishReportsProgress] = useState(true)
    const [serverUrl, setServerUrl] = useState()
    const [waitReports, setWaitReports] = useState(true)

    /* ACTUALIZACIÓN POST CAÍDA DE BBDD */
    const [numerosEnReportes, setNumerosEnReportes] = useState()
    const [reportsToShow, setReportsToShow] = useState([])
    const [valueFilter, setValueFilter] = useState('')
    const [tipoReporteSeleccionado, setTipoReporteSeleccionado] = useState('')
    const [reportesCalendario, setReportesCalendario] = useState([])
    const [dashboardCache, setDashboardCache] = useState({})
    const excludedReportIdsRef = useRef(new Set())
    const [excludedReportIds, setExcludedReportIdsState] = useState(new Set())

    const setExcludedReportIds = useCallback((val) => {
        setExcludedReportIdsState((prev) => {
            const next = typeof val === 'function' ? val(prev) : val
            excludedReportIdsRef.current = next
            return next
        })
    }, [])

    const [openComentarioFinalDialog, setOpenComentarioFinalDialog] =
		useState(false)
    const [isTerminarJornada, setIsTerminarJornada] = useState(false)

    const [reportQueue, setReportQueue] = useState([])

    const [messageType, setMessageType] = useState('')
    const [sortField, setSortField] = useState(null)
    const [sortOrder, setSortOrder] = useState(-1)
    const [isDeletedView, setIsDeletedView] = useState(false)

    const [openBulkFinishDialog, setOpenBulkFinishDialog] = useState(false)
    const [reportsToBulkFinish, setReportsToBulkFinish] = useState([])
    const [isLogoutPending, setIsLogoutPending] = useState(false)

    const ejecutarTerminoJornada = useState(0)

    const navigate = useNavigate()

    const isFetchingReportsRef = useRef(false)
    const isFetchingPaginatedRef = useRef(false)
    const isFetchingNumbersRef = useRef(false)

    const lastReportsFetchIdRef = useRef(0)
    const lastPaginatedFetchIdRef = useRef(0)
    const lastNumbersFetchIdRef = useRef(0)
    const isInitializedRef = useRef(false)

    useEffect(() => {
        isInitializedRef.current = false
    }, [userData])

    const updateLocalReport = useCallback(
        async (reportId, updates) => {
            console.log(
                `[ReportsContext] Updating local report ${reportId} with`,
                updates
            )

            const updater = (prevList) => {
                if (!prevList || prevList.length === 0) return prevList

                const reportIndex = prevList.findIndex((r) => r._id === reportId)
                if (reportIndex === -1) return prevList

                const newList = [...prevList]
                newList[reportIndex] = { ...newList[reportIndex], ...updates }
                return newList
            }

            setPriorityAssignments(updater)
            setNormalAssignments(updater)
            setReports(updater)
            setReportsToShow(updater)

            setReport((prevReport) => {
                if (prevReport && prevReport._id === reportId) {
                    return { ...prevReport, ...updates }
                }
                return prevReport
            })

            // Ensure persistence in IndexedDB for offline resilience
            try {
                const allLocal = await reportsDatabase.consultar()
                let reportToSave = allLocal.find(
                    (r) => String(r._id) === String(reportId)
                )

                if (!reportToSave && reports) {
                    const memReport = reports.find(
                        (r) => String(r._id) === String(reportId)
                    )
                    if (memReport) {
                        reportToSave = { ...memReport }
                    }
                }

                if (reportToSave) {
                    const updated = { ...reportToSave, ...updates }
                    await reportsDatabase.actualizar(updated)
                    console.log(
                        `[ReportsContext] Successfully persisted ${reportId} to IndexedDB.`
                    )
                } else {
                    const fallbackReport = { _id: reportId, ...updates }
                    await reportsDatabase.actualizar(fallbackReport)
                    console.log(
                        `[ReportsContext] Fallback persisted report stub ${reportId} to IndexedDB.`
                    )
                }
            } catch (error) {
                console.error(
                    '[ReportsContext] Error persisting updated report to IndexedDB:',
                    error
                )
            }
        },
        [
            setReports,
            setReport,
            setPriorityAssignments,
            setNormalAssignments,
            setReportsToShow
        ]
    )

    useEffect(() => {
        setExcludedReportIds(new Set())
    }, [siteSelected, tipoReporteSeleccionado])

    useEffect(() => {
        if (reportQueue.length > 0) {
            const nextItem = reportQueue[0]
            if (nextItem.action === 'LOGOUT') {
                logout(true)
                setReportQueue([])
            } else {
                setReport(nextItem)
                terminarJornada()
            }
        } else {
        }
    }, [reportQueue])

    const initiateEndAllShifts = async (andLogout = false) => {
        const isAnyOperator =
			isOperator || isUniversalInspector || isOperatorInspector
        if (!isAnyOperator) {
            if (andLogout) logout()
            return
        }

        if (!isOnline) {
            setstatus({
                status: 'error',
                title: 'Sin conexión',
                message:
					'Debe estar conectado a internet para terminar sus jornadas y sincronizar las horas antes de salir.',
                severity: 'warning'
            })
            return
        }

        if (!isOnline) {
            alert(
                'Debe estar conectado a internet para terminar sus jornadas y sincronizar las horas antes de salir.'
            )
            return
        }

        try {
            setLoadingLogo(true)
            const { openReports } = await ReportsService.checkOpenReportForUser()

            if (openReports && openReports.length > 0) {
                if (openReports.length > 1) {
                    setReportsToBulkFinish(openReports)
                    setIsLogoutPending(andLogout)
                    setOpenBulkFinishDialog(true)
                } else {
                    setstatus({
                        status: 'generating',
                        title: 'Pauta encontrada',
                        message:
							'Se ha encontrado una pauta abierta. Debe Terminar Jornada.',
                        severity: 'info'
                    })
                    const queue = [...openReports]
                    if (andLogout) {
                        queue.push({ action: 'LOGOUT' })
                    }
                    setReportQueue(queue)
                }
            } else {
                if (andLogout) {
                    logout()
                }
            }
        } catch (error) {
            console.error('Error during end all shifts check:', error)
            if (andLogout) logout()
        } finally {
            setLoadingLogo(false)
        }
    }

    const handleFinishReportBulk = async (reportId, data) => {
        try {
            console.log(`[ReportsContext] Bulk finishing report ${reportId}`, data)
            const targetReport = reportsToBulkFinish.find((r) => r._id === reportId)
            if (!targetReport) return

            let executionId =
				targetReport.execution?._id ||
				targetReport.tieneEjecucionEnDispositivo?._id

            if (!executionId) {
                await executionReportsDatabase.initDb()
                const ejecuciones = await executionReportsDatabase.consultarTodas()
                const ejecucion = ejecuciones.find((e) => {
                    const eReportId = e.reportId
                        ? String(e.reportId)
                        : e.report && e.report._id
                            ? String(e.report._id)
                            : e.report
                                ? String(e.report)
                                : null
                    return eReportId === String(reportId)
                })
                if (ejecucion) executionId = ejecucion._id
            }

            if (executionId) {
                await ExecutionReportsService.finishShift(executionId, {
                    comentario: data.comentario,
                    operarios: data.operarios
                })
                await executionReportsDatabase.eliminar(executionId)

                setReports((prev) => prev.filter((r) => r._id !== reportId))
                setReportsToShow((prev) => prev.filter((r) => r._id !== reportId))
                setPriorityAssignments((prev) =>
                    prev.filter((r) => r._id !== reportId)
                )
                setNormalAssignments((prev) => prev.filter((r) => r._id !== reportId))
            } else {
                console.warn(
                    `[ReportsContext] Execution not found for bulk report ${reportId}`
                )
            }
        } catch (error) {
            console.error(
                `[ReportsContext] Error in bulk finish for ${reportId}:`,
                error
            )
        }
    }

    const prefetchDashboardReports = async (siteId) => {
        if (!siteId) return
        const statesToPrefetch = [
            'Asignar',
            'En proceso',
            'Por cerrar',
            'Completadas'
        ]
        const typesToFetch = tipoReporteSeleccionado
            ? [tipoReporteSeleccionado]
            : []

        if (typesToFetch.length === 0) {
            console.log(
                '[ReportsContext] Skipping prefetch for dashboard as no specific report type is selected.'
            )
            return
        }

        console.log('[ReportsContext] Starting prefetch for dashboard...')

        for (const type of typesToFetch) {
            statesToPrefetch.forEach((state) => {
                const finalSiteId =
					siteId === 'none' || siteId === 'all'
					    ? 'all'
					    : siteSelected?._id || siteId
                ReportsService.reportesPaginados(state, 0, 10, finalSiteId, type)
                    .then((data) => {
                        const key = `${type}-${state}-${finalSiteId}-default-default-false`
                        setDashboardCache((prev) => ({
                            ...prev,
                            [key]: { reportes: data.reportes, totalItems: data.totalItems }
                        }))
                    })
                    .catch((err) =>
                        console.log(
                            `[ReportsContext] Prefetch failed for ${type}-${state}`,
                            err
                        )
                    )
            })
        }
    }

    const refreshNumbers = useCallback(async () => {
        if (siteSelected) {
            const fetchId = ++lastNumbersFetchIdRef.current
            isFetchingNumbersRef.current = true
            try {
                let siteId
                const isAdminGlobal =
					admin || isSuperAdmin || isUniversalInspector || isUniversalChief
                const isMultiSiteUser = userData?.obras && userData.obras.length > 1

                const isAllSelected =
					siteSelected === 'all' ||
					siteSelected?._id === 'all' ||
					siteSelected?.idObra === 'none'
                if (isAllSelected && isMultiSiteUser && !isAdminGlobal) {
                    siteId = userData.obras.map((o) => o._id || o).join(',')
                } else {
                    siteId = isAllSelected ? 'all' : siteSelected?._id || siteSelected
                }
                console.log(
                    '[ReportsContext] Calling getNumbers with siteId:',
                    siteId,
                    'fetchId:',
                    fetchId
                )
                const numbers = await ReportsService.getNumbers(siteId)
                if (fetchId === lastNumbersFetchIdRef.current) {
                    console.log(
                        '[ReportsContext] getNumbers returned for fetchId:',
                        fetchId,
                        'data:',
                        numbers
                    )
                    setNumerosEnReportes(numbers)
                } else {
                    console.log(
                        '[ReportsContext] Discarding getNumbers response for stale fetchId:',
                        fetchId
                    )
                }
            } catch (error) {
                console.error('Error refreshing numbers:', error)
            } finally {
                if (fetchId === lastNumbersFetchIdRef.current) {
                    isFetchingNumbersRef.current = false
                }
            }
        } else {
            console.warn(
                '[ReportsContext] refreshNumbers called but siteSelected is null/undefined'
            )
        }
    }, [
        siteSelected,
        userData,
        admin,
        isSuperAdmin,
        isUniversalInspector,
        isUniversalChief
    ])

    useEffect(() => {
        if (
            siteSelected &&
			(!isOperator || isOperatorInspector || isUniversalChief || isObserver || isUniversalInspector)
        ) {
            refreshNumbers()
        }
    }, [
        siteSelected,
        refreshNumbers,
        isOperator,
        isOperatorInspector,
        isUniversalChief,
        isObserver,
        isUniversalInspector
    ])

    useEffect(() => {
        reportsDatabase.initDbReports()
    }, [])

    useEffect(() => {
        if (progress > 0 && report && report.progress !== progress) {
            updateLocalReport(report._id, { progress })
        }
    }, [progress, report, updateLocalReport])

    useEffect(() => {
        if (process.env.NODE_ENV === 'production') {
            setServerUrl('https://mantencion.icv.cl')
        } else {
            setServerUrl(process.env.REACT_APP_API_URL)
        }
    }, [])

    useEffect(() => {
        if (reportsProgress) {
            console.log(reportsProgress)
            /* setWaitReports(false) */
            if (reportsProgress.loaded < reportsProgress.total) {
                setFinishReportsProgress(false)
            } else {
                setTimeout(() => {
                    setFinishReportsProgress(true)
                }, 1000)
            }
        }
    }, [reportsProgress])

    useEffect(() => {
        if (isOnline && userData && isAuthenticated) {
            if (isOperator && !admin) {
                saveReportsFromLocalDatabase().then(() => {
                    /* stateReports() */
                })
            }
        }
    }, [
        userData,
        isOnline,
        isAuthenticated,
        isOperator,
        admin,
        isShiftManager,
        isChiefMachinery,
        isSapExecutive,
        isOperatorInspector
    ])

    const saveReportsFromLocalDatabase = async () => {
        return ReportsService.saveReportsFromLocalDatabase()
    }

    const terminarJornada = () => {
        if (isOnline) {
            setIsTerminarJornada(true)
            setOpenComentarioFinalDialog(true)
        } else {
            setAlertSimple(
                'Error',
                'Revise su conexión',
                'No se puede enviar OT sin conexión a internet'
            )
        }
    }

    const enviarOt = () => {
        console.log('Verificando progreso para enviar OT:', progress)
        if (isOnline) {
            console.log(report)
            if (report.testMode) {
                setIsTerminarJornada(false)
                setOpenComentarioFinalDialog(true)
                setMessageType('ok')
            } else {
                if (progress === 100) {
                    setIsTerminarJornada(false)
                    setOpenComentarioFinalDialog(true)
                    setMessageType('ok')
                } else {
                    setAlertSimple(
                        'Error',
                        'No se puede enviar OT',
                        'La OT no ha sido completada al 100%'
                    )
                }
            }
        } else {
            setAlertSimple(
                'Error',
                'Revise su conexión',
                'No se puede enviar OT sin conexión a internet'
            )
        }
    }

    const cerrarOt = () => {
        if (isOnline) {
            setIsTerminarJornada(false)
            setOpenComentarioFinalDialog(true)
            setMessageType('ok')
        } else {
            setAlertSimple(
                'Error',
                'Revise su conexión',
                'No se puede enviar OT sin conexión a internet'
            )
        }
    }

    const dataReturned = async (data) => {
        const navigateType = isTerminarJornada
            ? 'reject-for-end-day'
            : messageType === 'rejectReport'
                ? 'reject-to-previous-level'
                : 'sending-to-next-level'
        console.log('[ReportsContext] dataReturned triggered:', {
            navigateType,
            data,
            isTerminarJornada
        })

        if (navigateType === 'reject-for-end-day') {
            try {
                setLoadingLogo(true)
                if (!report) {
                    throw new Error('No hay reporte activo para terminar la jornada.')
                }
                let executionId =
					report.tieneEjecucionEnDispositivo?._id || report.execution?._id

                if (!executionId) {
                    try {
                        await executionReportsDatabase.initDb()
                        const ejecuciones = await executionReportsDatabase.consultarTodas()
                        console.log(
                            '[ReportsContext] Searching execution for report:',
                            report._id,
                            'in',
                            ejecuciones.length,
                            'executions'
                        )
                        console.log(
                            '[ReportsContext] Executions in DB:',
                            ejecuciones.map((e) => ({
                                _id: e._id,
                                report: e.report,
                                reportId: e.reportId
                            }))
                        )

                        const targetReportId = String(report._id)
                        const ejecucion = ejecuciones.find((e) => {
                            const eReportId = e.reportId
                                ? String(e.reportId)
                                : e.report && e.report._id
                                    ? String(e.report._id)
                                    : e.report
                                        ? String(e.report)
                                        : null
                            return eReportId === targetReportId
                        })

                        if (ejecucion) {
                            console.log(
                                '[ReportsContext] Found execution in DB:',
                                ejecucion._id
                            )
                            executionId = ejecucion._id
                        } else {
                            console.warn(
                                '[ReportsContext] Execution not found in DB for report:',
                                report._id
                            )
                        }
                    } catch (dbError) {
                        console.error('Error querying executionReportsDatabase:', dbError)
                    }
                }

                if (executionId) {
                    await ExecutionReportsService.finishShift(executionId, {
                        comentario: data.comentario,
                        operarios: data.operarios
                    })

                    // Cleanup local execution data
                    console.log(
                        `[ReportsContext] Cleaning up local execution data after finishShift: ${executionId}`
                    )
                    await executionReportsDatabase.eliminar(executionId)

                    setstatus({
                        status: 'completed',
                        title: 'Jornada terminada',
                        message: 'Reporte enviado para reasignación',
                        severity: 'success'
                    })
                } else {
                    const reportFromList = reports.find((r) => r._id === report._id)
                    if (
                        reportFromList &&
						(reportFromList.tieneEjecucionEnDispositivo ||
							reportFromList.execution)
                    ) {
                        executionId =
							reportFromList.tieneEjecucionEnDispositivo?._id ||
							reportFromList.execution?._id
                        if (executionId) {
                            await ExecutionReportsService.finishShift(executionId, {
                                comentario: data.comentario,
                                operarios: data.operarios
                            })
                            // Cleanup local execution data
                            console.log(
                                `[ReportsContext] Cleaning up local execution data after finishShift: ${executionId}`
                            )
                            await executionReportsDatabase.eliminar(executionId)

                            setstatus({
                                status: 'completed',
                                title: 'Jornada terminada',
                                message: 'Reporte enviado para reasignación',
                                severity: 'success'
                            })
                        } else {
                            throw new Error(
                                'No se pudo encontrar la ejecución activa para terminar la jornada.'
                            )
                        }
                    } else {
                        throw new Error(
                            'No se pudo encontrar la ejecución activa para terminar la jornada.'
                        )
                    }
                }
            } catch (error) {
                console.error('Error finishing shift:', error)
                setAlertSimple(
                    'Error',
                    `No se pudo terminar la jornada para la OT ${report.newIdIndex || report.idIndex}: ` +
						(error.response?.data?.message || error.message)
                )
            } finally {
                setLoadingLogo(false)
                const queueCount = reportQueue.length
                setReportQueue((prev) => prev.slice(1))
                if (queueCount === 1) {
                    console.log(
                        '[ReportsContext] Final report in queue processed. Refreshing reports.'
                    )
                    await getReports()
                }
            }
            return
        }

        const updatedReport = ReportsService.processReportData({
            report,
            progress,
            messageType: navigateType, // Use the determined navigateType
            data,
            userData
        })

        console.log(
            '[ReportsContext] Sending updated report to backend:',
            updatedReport
        )

        await elevarReporte(updatedReport)

        console.log(
            '[ReportsContext] Report saved successfully. Refreshing list and navigating...'
        )

        const isFromReports = location.pathname.includes('assignment') && location.state?.from === 'reports'
        const isReviewerRole = admin || isSuperAdmin || isSapExecutive || isShiftManager || isChiefMachinery || isUniversalChief || isOperatorInspector || isObserver

        if (
            updatedReport.level === 4 ||
            navigateType === 'reject-to-previous-level' ||
            isReviewerRole ||
            isFromReports
        ) {
            navigate('/reports')
        } else {
            navigate('/assignment')
        }
    }

    const downloadPautas = useCallback(async () => {
        const pautasData = await ReportsService.downloadPautas()
        console.log(pautasData)
        setPautas(pautasData)
        setPautasCache(pautasData)
    }, [setPautas, setPautasCache])

    const getReportsFromIndexedDb = useCallback(async () => {
        const reportsResponse = await ReportsService.getReportsFromIndexedDb()
        setReportsCache(reportsResponse)
    }, [setReportsCache])

    const getReports = useCallback(async () => {
        const fetchId = ++lastReportsFetchIdRef.current
        isFetchingReportsRef.current = true

        setStatusReports(true)
        setExcludedReportIds(new Set())

        console.log(
            '[ReportsContext] getReports triggered. fetchId:',
            fetchId,
            'Role status:',
            {
                admin,
                isOperator,
                isSapExecutive,
                isShiftManager,
                isChiefMachinery,
                isOperatorInspector,
                siteSelected: siteSelected?.idObra || siteSelected?._id || siteSelected
            }
        )

        // If offline, load from DB immediately and exit early without any API calls or errors
        if (!navigator.onLine) {
            setAssignmentsError(null)
            try {
                const reportsFromDb = await ReportsService.getReportsFromIndexedDb()
                if (fetchId !== lastReportsFetchIdRef.current) return

                if (reportsFromDb && reportsFromDb.length > 0) {
                    setReports(reportsFromDb)
                    if (fetchId === lastReportsFetchIdRef.current) {
                        setMessage('Sincronizado (Modo Offline)')
                        setLoadingLogo(false)
                        setStatusReports(false)
                        setWaitReports(false)
                    }
                } else {
                    if (fetchId === lastReportsFetchIdRef.current) {
                        setMessage('Sin reportes en modo offline')
                        setLoadingLogo(false)
                        setStatusReports(false)
                        setWaitReports(false)
                    }
                }
            } finally {
                if (fetchId === lastReportsFetchIdRef.current) {
                    isFetchingReportsRef.current = false
                }
            }
            return
        }

        // Load from IndexedDB first for a quick UI update
        const reportsFromDb = await ReportsService.getReportsFromIndexedDb()
        if (fetchId !== lastReportsFetchIdRef.current) return

        if (reportsFromDb && reportsFromDb.length > 0) {
            setReports(reportsFromDb)
        } else if (isOnline) {
            setLoadingLogo(true) // Only show big logo if DB is empty and we are online
        }

        // Then, if online, fetch from the server to get the latest data
        if (isOnline && userData) {
            try {
                const reportsFromApi = await ReportsService.getReportsFromApi({
                    userData,
                    isAuthenticated,
                    admin,
                    isOperator,
                    isSapExecutive,
                    isShiftManager,
                    isChiefMachinery,
                    isOperatorInspector,
                    isUniversalInspector,
                    isUniversalChief,
                    siteSelected,
                    setLoadingLogo,
                    setAssignmentsError,
                    setStatusReports,
                    setWaitReports,
                    setReportsToShow,
                    downloadPautas
                })

                if (fetchId !== lastReportsFetchIdRef.current) {
                    console.log(
                        '[ReportsContext] Discarding api reports for stale fetchId:',
                        fetchId
                    )
                    return
                }

                if (!navigator.onLine) {
                    console.warn(
                        '[ReportsContext] Connection lost during fetch, keeping local reports.'
                    )
                    setMessage('Sincronizado (Modo Offline)')
                    return
                }

                // Update the state with the fresh data from the API
                setReports((prev) => {
                    const merged = reportsFromApi.map((apiR) => {
                        const localR = prev.find((r) => r._id === apiR._id)
                        if (localR) {
                            const hasOngoingLocal = localR.ejecuciones?.some(
                                (e) => e.termino === null
                            )
                            return {
                                ...apiR,
                                ejecuciones: hasOngoingLocal
                                    ? localR.ejecuciones
                                    : apiR.ejecuciones || localR.ejecuciones,
                                tieneEjecucionEnDispositivo:
									localR.tieneEjecucionEnDispositivo ||
									apiR.tieneEjecucionEnDispositivo,
                                progress:
									localR.progress > apiR.progress
									    ? localR.progress
									    : apiR.progress
                            }
                        }
                        return apiR
                    })
                    const localOnly = prev.filter(
                        (r) =>
                            !reportsFromApi.some((apiR) => apiR._id === r._id) &&
							r.isOfflineCreated
                    )
                    return [...merged, ...localOnly]
                })

                // Centralized fetch for numbers to avoid duplication
                if (
                    siteSelected &&
					(!isOperator || isOperatorInspector || isUniversalChief || isObserver || isUniversalInspector)
                ) {
                    refreshNumbers()
                }
                setMessage('Sincronizado')
            } catch (error) {
                console.error('Failed to fetch reports from API:', error)
                if (fetchId === lastReportsFetchIdRef.current) {
                    if (navigator.onLine) {
                        setAssignmentsError('Error al sincronizar los reportes.')
                        setMessage('Error de sincronización')
                    } else {
                        setMessage('Sincronizado (Modo Offline)')
                    }
                }
            }
        } else {
            if (fetchId === lastReportsFetchIdRef.current) {
                setMessage('Sincronizado (Modo Offline)')
            }
        }

        if (fetchId === lastReportsFetchIdRef.current) {
            // Ensure loading indicators are turned off
            setLoadingLogo(false)
            setStatusReports(false)
            setWaitReports(false)
            isFetchingReportsRef.current = false
        }
    }, [
        isOnline,
        admin,
        isOperator,
        isOperatorInspector,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        isUniversalInspector,
        isUniversalChief,
        siteSelected,
        userData,
        isAuthenticated,
        downloadPautas,
        isObserver
    ])

    const removeReportFromReportsToShow = useCallback((reportId) => {
        setExcludedReportIds((prev) => {
            const next = new Set(prev)
            next.add(reportId)
            return next
        })
        setReportsToShow((prevReports) =>
            prevReports.filter((report) => report._id !== reportId)
        )
        setTotalReportsList((prev) => Math.max(0, prev - 1))
    }, [])

    /* useEffect(() => {
        if (isAuthenticated && siteSelected) {
            const isUniversal = isUniversalInspector || isUniversalChief
            if (isUniversal) {
                const defaultType = 'Inspección'
                const defaultState = 'all'

                setTipoReporteSeleccionado(defaultType)
                reportesSeleccionados(defaultState, 0, 10, defaultType, null, -1)
            }
        }
    }, [isAuthenticated, siteSelected, isUniversalInspector, isUniversalChief]) */

    const getData = (data) => {
        addNotification({
            icon: logoNotification,
            title: data.title,
            subtitle: data.subtitle,
            message: data.message,
            theme: 'red',
            native: true
        })
        if (data.report) {
            getReports()
        }
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (reports.length > 0) {
                if (reportsCache.length === 0) {
                    setReportsCache(reports)
                }
                const reportsResumeCache = []
                reports.forEach((report) => {
                    if (report) {
                        reportsResumeCache.push({
                            _id: report._id,
                            idIndex: report.idIndex,
                            newIdIndex: report.newIdIndex,
                            dateInit: report.dateInit,
                            datePrev: report.datePrev,
                            isAutomatic: report.isAutomatic,
                            guide: report.guide,
                            equ: report.maquina ? report.maquina.equ : null
                        })
                    }
                })
                setReportsResume(reportsResumeCache)
                setAssignments(reports)
                filterReports(reports)
            } else {
                setAssignments([])
                setReportsResume([])
                if (!siteSelected) {
                    setMessage('Descargando recursos')
                }
            }
        }
    }, [reports, isAuthenticated])

    const elevarReporte = async (reportDataToSend, silent = false) => {
        console.log('Data to elevate:', JSON.stringify(reportDataToSend, null, 2)) // DEBUG LOG
        // Sanitize the report object to match the backend DTO
        const reportDto = {
            _id: reportDataToSend._id,
            state: reportDataToSend.state,
            level: reportDataToSend.level,
            progress: reportDataToSend.progress,
            endReport: reportDataToSend.endReport,
            dateClose: reportDataToSend.dateClose,
            origen: reportDataToSend.origen,

            // Map populated objects back to IDs
            maquina: reportDataToSend.maquina?._id || reportDataToSend.maquina,
            obra: reportDataToSend.obra?._id || reportDataToSend.obra,
            usersAssigned: reportDataToSend.usersAssigned
                ?.map((u) => u._id || u)
                .filter(Boolean),

            // Handle reviewer fields
            shiftManagerApprovedBy:
				reportDataToSend.shiftManagerApprovedBy?._id ||
				reportDataToSend.shiftManagerApprovedBy,
            shiftManagerApprovedDate: reportDataToSend.shiftManagerApprovedDate,
            chiefMachineryApprovedBy:
				reportDataToSend.chiefMachineryApprovedBy?._id ||
				reportDataToSend.chiefMachineryApprovedBy,
            chiefMachineryApprovedDate: reportDataToSend.chiefMachineryApprovedDate,
            sapExecutiveApprovedBy:
				reportDataToSend.sapExecutiveApprovedBy?._id ||
				reportDataToSend.sapExecutiveApprovedBy,

            emailing: reportDataToSend.emailing,
            fullNameWorker: reportDataToSend.fullNameWorker,
            operadores: reportDataToSend.operadores,
            message: reportDataToSend.message,
            updatedBy: reportDataToSend.updatedBy?._id || reportDataToSend.updatedBy,

            historialAsignaciones: Array.isArray(
                reportDataToSend.historialAsignaciones
            )
                ? reportDataToSend.historialAsignaciones
                    .map((item) => {
                        const asignadoPor =
								item.asignadoPor?._id ||
								item.asignadoPor?.id ||
								item.asignadoPor
                        let asignadoA =
								item.asignadoA?._id || item.asignadoA?.id || item.asignadoA

                        // If asignadoA is missing, try to get it from the main usersAssigned array
                        if (!asignadoA) {
                            if (
                                reportDataToSend.usersAssigned &&
									reportDataToSend.usersAssigned.length > 0
                            ) {
                                const assignedUser = reportDataToSend.usersAssigned[0]
                                if (
                                    assignedUser &&
										typeof assignedUser === 'object' &&
										assignedUser._id
                                ) {
                                    asignadoA = assignedUser._id
                                } else if (assignedUser && typeof assignedUser === 'string') {
                                    asignadoA = assignedUser
                                }
                            }
                        }

                        return {
                            _id: item._id,
                            asignadoPor,
                            asignadoA,
                            id: item.id,
                            fecha: item.fecha
                        }
                    })
                    .filter((h) => h.asignadoPor && h.asignadoA)
                : reportDataToSend.historialAsignaciones
        }

        reportDto.urlPdf = null

        // Remove undefined properties so they don't get sent in the payload
        Object.keys(reportDto).forEach(
            (key) => reportDto[key] === undefined && delete reportDto[key]
        )

        try {
            if (!silent) setLoadingLogo(true)
            await ReportsService.editReport(reportDto)

            // Cleanup local execution data after successful elevation
            const execId =
				reportDataToSend.tieneEjecucionEnDispositivo?._id ||
				reportDataToSend.execution?._id
            if (execId) {
                console.log(
                    `[ReportsContext] Cleaning up local execution data: ${execId}`
                )
                await executionReportsDatabase.eliminar(execId)
            }

            console.log(
                `[ReportsContext] Cleaning up main report from local database: ${reportDataToSend._id}`
            )
            await reportsDatabase.eliminar(reportDataToSend._id)

            const isSearching = !!(valueFilter && valueFilter.trim() !== '')
            if (isSearching) {
                await updateLocalReport(reportDataToSend._id, {
                    origen: reportDataToSend.origen ?? false,
                    state: reportDataToSend.state ?? 'Asignar',
                    level: reportDataToSend.level ?? 0,
                    usersAssigned: reportDataToSend.usersAssigned ?? []
                })
                setDashboardCache({})
                await refreshNumbers()
            } else {
                const filterOut = (prev) =>
                    prev.filter((r) => r._id !== reportDataToSend._id)
                setReports(filterOut)
                setReportsToShow(filterOut)
                setPriorityAssignments(filterOut)
                setNormalAssignments(filterOut)

                if (silent) {
                    setDashboardCache({})
                    await refreshNumbers()
                    await reloadCurrentPage()
                } else {
                    await getReports()
                    setDashboardCache({})
                    await reloadCurrentPage()
                }
            }
        } catch (error) {
            console.error(
                'Error al elevar el reporte:',
                error.response ? error.response.data : error
            )
            // setAlertSimple('Error', `No se pudo enviar la OT a revisión: ${error.response?.data?.message || ''}`)
            throw error
        } finally {
            if (!silent) setLoadingLogo(false)
        }
    }

    const changeToOrigen = async (reportIds) => {
        const toUpdate = reportsToShow.filter(
            (r) => reportIds.includes(r._id) && r.estado === 'Asignar'
        )

        if (toUpdate.length === 0) {
            setstatus({
                status: 'error',
                title: 'No hay reportes válidos',
                message:
					'Solo se pueden cambiar a Origen los reportes que están en estado "Asignar".',
                severity: 'warning'
            })
            return
        }

        try {
            setstatus({
                status: 'generating',
                title: 'Cambiando a Origen',
                message: `Cambiando ${toUpdate.length} reporte(s) a Origen...`,
                severity: 'info'
            })
            setDashboardCache({})

            const isSearching = !!(valueFilter && valueFilter.trim() !== '')
            for (const report of toUpdate) {
                await ReportsService.editReport({ _id: report._id, origen: true })
                if (isSearching) {
                    await updateLocalReport(report._id, { origen: true })
                }
            }

            setstatus({
                status: 'completed',
                title: 'Proceso completado',
                message: `${toUpdate.length} reporte(s) cambiados a Origen correctamente.`,
                severity: 'success'
            })

            await refreshNumbers()
            if (!isSearching) {
                await reloadCurrentPage()
            }
        } catch (error) {
            console.error('Error changing to Origen:', error)
            setstatus({
                status: 'error',
                title: 'Error',
                message: 'Ocurrió un error al cambiar los reportes a Origen.',
                severity: 'error'
            })
        }
    }

    const saveReport = async (reportData) => {
        setMessage('Guardando reportes')

        const reportDto = { ...reportData }

        if (reportDto.maquina && typeof reportDto.maquina === 'object') {
            reportDto.maquina = reportDto.maquina._id
        }
        if (reportDto.obra && typeof reportDto.obra === 'object') {
            reportDto.obra = reportDto.obra._id
        }
        if (reportDto.usersAssigned && Array.isArray(reportDto.usersAssigned)) {
            reportDto.usersAssigned = reportDto.usersAssigned.map((u) =>
                typeof u === 'object' ? u._id : u
            )
        }

        if (
            reportDto.historialAsignaciones &&
			Array.isArray(reportDto.historialAsignaciones)
        ) {
            reportDto.historialAsignaciones = reportDto.historialAsignaciones
                .map((item) => {
                    const asignadoPor =
						item.asignadoPor?._id || item.asignadoPor?.id || item.asignadoPor
                    let asignadoA =
						item.asignadoA?._id || item.asignadoA?.id || item.asignadoA

                    if (
                        !asignadoA &&
						reportDto.usersAssigned &&
						reportDto.usersAssigned.length > 0
                    ) {
                        asignadoA = reportDto.usersAssigned[0]
                    }

                    return {
                        _id: item._id,
                        asignadoPor,
                        asignadoA,
                        id: item.id,
                        fecha: item.fecha
                    }
                })
                .filter((h) => h.asignadoPor && h.asignadoA) // Ensure we don't send entries missing required IDs
        }

        try {
            console.log(
                'ReportsContext: Saving sanitized DTO:',
                JSON.stringify(reportDto, null, 2)
            )
            await ReportsService.saveReport(reportDto)
            await refreshNumbers()
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }

    const saveReportLocal = async (reportData) => {
        try {
            await ReportsService.saveReportLocal(reportData)
            setLoading(false)
            return null
        } catch (error) {
            console.log(error)
            setLoading(false)
            return error
        }
    }

    const createReport = async (reportData) => {
        console.log(reportData)
        try {
            setDashboardCache({})
            const response = await ReportsService.createReport(reportData)
            console.log(response)
            await getReports()
            return response
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (assignments) {
            console.log('Processing assignments:', assignments.length)
            const priorityAssignmentsCache = []
            const normalAssignmentsCache = []

            // Pre-process guides and priority for all assignments in one pass
            const processed = assignments.map((assignment) => {
                const updated = { ...assignment }
                updated._guide =
					assignment.guide === 'Pauta de Inspección' ? 'PI' : assignment.guide
                return updated
            })

            if (isShiftManager) {
                processed.forEach((assignment) => {
                    const isOwnLevel0 =
						(!assignment.level || assignment.level === 0) &&
						assignment.usersAssigned?.[0]?._id === userData?._id
                    const isLevel1 = assignment.level === 1

                    if (isOwnLevel0 || isLevel1) {
                        assignment.isPrioritary = true
                        priorityAssignmentsCache.push(assignment)
                    } else {
                        assignment.isPrioritary = false
                        normalAssignmentsCache.push(assignment)
                    }
                })
            } else if (isChiefMachinery) {
                processed.forEach((assignment) => {
                    if (assignment.level === 2) {
                        assignment.isPrioritary = true
                        priorityAssignmentsCache.push(assignment)
                    } else {
                        assignment.isPrioritary = false
                        normalAssignmentsCache.push(assignment)
                    }
                })
            } else {
                // Operators, Admins, SAP
                processed.forEach((assignment) => {
                    if (assignment.level !== 4) {
                        priorityAssignmentsCache.push(assignment)
                    }
                })
            }

            setNormalAssignments(normalAssignmentsCache)

            // Remove duplicates from priority assignments (just in case)
            const uniquePriority = Array.from(
                new Map(priorityAssignmentsCache.map((p) => [p._id, p])).values()
            )
            setPriorityAssignments(uniquePriority)

            // Save to IndexedDB (handles both population and cleanup of empty lists)
            // CRITICAL for Universal roles: Prevent auto-wiping when online,
            // since they prepare reports manually instead of via standard assignment sync.
            const isUniversal = isUniversalChief || isUniversalInspector
            if (!isUniversal || !isOnline) {
                ReportsService.saveReportsToIndexedDb(assignments)
            }
        }
    }, [
        assignments,
        admin,
        isChiefMachinery,
        isOperator,
        isSapExecutive,
        isShiftManager,
        userData,
        isOnline,
        isUniversalChief,
        isUniversalInspector
    ])

    useEffect(() => {
        if (
            userData &&
			(admin ||
				isOperator ||
				isSapExecutive ||
				isShiftManager ||
				isChiefMachinery ||
				isUniversalChief ||
				isUniversalInspector ||
				isOperatorInspector ||
				isObserver)
        ) {
            getReports()
        }
    }, [
        admin,
        isOperator,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        isUniversalChief,
        isUniversalInspector,
        isOperatorInspector,
        isOnline,
        siteSelected,
        userData,
        isObserver
    ])

    useEffect(() => {
        if (userData && sites && sites.length > 0 && !isInitializedRef.current) {
            const isUniversalUser = isUniversalInspector || isUniversalChief
            const isExecutive =
				admin ||
				isSuperAdmin ||
				isUniversalInspector ||
				isUniversalChief ||
				isSapExecutive ||
				isChiefMachinery ||
				isShiftManager

            console.log(
                '[ReportsContext] Initializing siteSelected. isExecutive:',
                isExecutive,
                'isUniversalUser:',
                isUniversalUser
            )

            if (isUniversalUser) {
                const universalSite = sitesToSelection.find((s) => s._id === 'universal')
                if (universalSite) {
                    console.log(
                        '[ReportsContext] Setting siteSelected to universal option for universal user'
                    )
                    setSiteSelected(universalSite)
                    isInitializedRef.current = true
                }
            } else if (isExecutive) {
                const allSitesOption = {
                    _id: 'all',
                    idObra: 'none',
                    idObraAlfa: 'ALL',
                    descripcion: 'TODAS LAS OBRAS',
                    mostrar: true,
                    status: true
                }
                console.log(
                    '[ReportsContext] Setting siteSelected to ALL SITES for executive'
                )
                setSiteSelected(allSitesOption)
                isInitializedRef.current = true
            } else if (userData.obras && userData.obras.length > 0) {
                const userSite = sites.find((s) => s._id === userData.obras[0])
                if (userSite) {
                    console.log(
                        '[ReportsContext] Setting siteSelected to user site:',
                        userSite.idObra
                    )
                    setSiteSelected(userSite)
                    isInitializedRef.current = true
                }
            } else {
                console.warn(
                    '[ReportsContext] Could not determine initial siteSelected.'
                )
            }
        }
    }, [
        userData,
        sites,
        sitesToSelection,
        setSiteSelected,
        admin,
        isSuperAdmin,
        isUniversalInspector,
        isUniversalChief,
        isSapExecutive,
        isChiefMachinery,
        isShiftManager,
        isOperatorInspector,
        isObserver
    ])

    const guardarContadorEnReporte = async (reporte) => {
        const response = await ReportsService.guardarContadorEnReporte(reporte)
        console.info(response.data, 'Contador reporte')
    }

    const saveReportsToIndexedDb = async () => {
        setMessage('Actualizando OTs')
        await ReportsService.saveReportsToIndexedDb(assignments)
        setMessage('')
        setLoading(false)
    }

    const filterReports = async (reports) => {
        await ReportsService.filterReports(reports)
    }

    const findDuplicates = (array) => {
        return ReportsService.findDuplicates(array)
    }

    const getReportsOffline = () => {
        getReportsFromIndexedDb()
    }

    const assignReport = async (reportId, assignmentData) => {
        try {
            const response = await ReportsService.assignReport(
                reportId,
                assignmentData
            )
            setDashboardCache({})
            await refreshNumbers()
            return response
        } catch (error) {
            console.error('Error assigning report:', error)
            throw error
        }
    }

    const borrarListaReportes = async (listaReportes) => {
        setDashboardCache({})
        const response = await ReportsService.borrarListaReportes(listaReportes)
        getReports()
        refreshNumbers()
        return response
    }

    const [lastListParams, setLastListParams] = useState(null)
    const [totalItemsInDeleted, setTotalItemsInDeleted] = useState(0)
    const [totalReportsList, setTotalReportsList] = useState(0)

    const updateNumbersLocally = useCallback((tipo, fromState, toState) => {
        setNumerosEnReportes((prev) => {
            if (!prev) return prev
            const next = JSON.parse(JSON.stringify(prev))
            const category = tipo === 'Inspección' ? 'inspecciones' : 'mantenciones'

            const mapStateToKey = (s) => {
                if (s === 'Asignar') return 'asignar'
                if (s === 'En proceso') return 'enProceso'
                if (s === 'Por cerrar') return 'porCerrar'
                if (s === 'Completadas') return 'completadas'
                if (s === 'Origen') return 'origen'
                return s
            }

            const fromKey = mapStateToKey(fromState)
            const toKey = mapStateToKey(toState)

            if (next[category] && next[category][fromKey] !== undefined) {
                next[category][fromKey] = Math.max(0, next[category][fromKey] - 1)
            }
            if (next[category] && next[category][toKey] !== undefined) {
                next[category][toKey] = next[category][toKey] + 1
            }

            return next
        })
    }, [])

    const reloadCurrentPage = useCallback(async () => {
        if (lastListParams) {
            console.log('[ReportsContext] Silently reloading current page...')
            const { estado, desde, maximo, tipoReporte, sortField, sortOrder, deleted } =
				lastListParams

            const queryEstado =
				estado === 'all' || estado === 'Todos' ? 'todos' : estado

            try {
                const { reportes, totalItems } = await ReportsService.reportesPaginados(
                    queryEstado,
                    desde,
                    maximo,
                    siteSelected?.idObra === 'none' || siteSelected?._id === 'all'
                        ? 'all'
                        : siteSelected?._id || siteSelected,
                    tipoReporte,
                    sortField,
                    sortOrder,
                    deleted
                )

                // Clear excluded IDs as we are getting a fresh slice from the server
                setExcludedReportIds(new Set())

                setReportsToShow(reportes)
                setTotalReportsList(totalItems)
                if (deleted) setTotalItemsInDeleted(totalItems)

                const obraParaFiltrar = siteSelected?.idObra === 'none' || siteSelected?._id === 'all'
                    ? 'all'
                    : siteSelected?._id || siteSelected
                const key = `${tipoReporte}-${estado}-${obraParaFiltrar}-${sortField || 'default'}-${sortOrder || 'default'}-${deleted}`

                if (desde === 0 && !deleted) {
                    setDashboardCache((prev) => ({
                        ...prev,
                        [key]: { reportes, totalItems }
                    }))
                }
            } catch (error) {
                console.error('[ReportsContext] Silent reload failed:', error)
            }
        }
    }, [lastListParams, siteSelected])

    const restoreReport = async (reportId) => {
        try {
            setLoadingLogo(true)
            setDashboardCache({})
            await ReportsService.restoreReport(reportId)
            setstatus({
                status: 'completed',
                title: 'Reporte restaurado',
                message: 'El reporte ha sido recuperado exitosamente',
                severity: 'success'
            })
            await getReports()
            refreshNumbers()
        } catch (error) {
            console.error('Error al restaurar el reporte:', error)
            setAlertSimple('Error', 'No se pudo restaurar el reporte')
        } finally {
            setLoadingLogo(false)
        }
    }

    const reportesSeleccionados = async (
        estado,
        desde,
        maximo,
        tipoReporte,
        sortField,
        sortOrder,
        deleted = false
    ) => {
        const fetchId = ++lastPaginatedFetchIdRef.current
        isFetchingPaginatedRef.current = true
        setStatusReports(true)

        console.log('[ReportsContext] Fetching paginated reports with params:', {
            estado,
            desde,
            maximo,
            tipoReporte,
            sortField,
            sortOrder,
            deleted,
            fetchId
        })

        setLastListParams({
            estado,
            desde,
            maximo,
            tipoReporte,
            sortField,
            sortOrder,
            deleted
        })
        setIsDeletedView(deleted)
        let obraParaFiltrar
        if (siteSelected) {
            obraParaFiltrar =
				siteSelected.idObra === 'none' || siteSelected._id === 'all'
				    ? 'all'
				    : siteSelected._id || siteSelected
        } else {
            obraParaFiltrar = 'all'
        }

        if (obraParaFiltrar) {
            const key = `${tipoReporte}-${estado}-${obraParaFiltrar}-p${desde}-${sortField || 'default'}-${sortOrder || 'default'}-${deleted}`

            if (!isOnline) {
                console.log(
                    '[ReportsContext] Offline detected. Filtering reports from IndexedDB locally.'
                )
                try {
                    const allLocalReports =
						await ReportsService.getReportsFromIndexedDb()
                    if (fetchId !== lastPaginatedFetchIdRef.current) return
                    let filtered = allLocalReports || []

                    // 1. Filtrar por Tipo de Reporte
                    if (tipoReporte) {
                        filtered = filtered.filter(
                            (r) =>
                                r.reportType === tipoReporte || r.tipoReporte === tipoReporte
                        )
                    }

                    // 2. Filtrar por Estado
                    if (estado && estado !== 'all' && estado !== 'Todos') {
                        filtered = filtered.filter(
                            (r) =>
                                String(r.state).toLowerCase() ===
									String(estado).toLowerCase() ||
								String(r.estado).toLowerCase() === String(estado).toLowerCase()
                        )
                    }

                    // 3. Filtrar por Obra
                    if (obraParaFiltrar && obraParaFiltrar !== 'all') {
                        filtered = filtered.filter((r) => {
                            const obraId = r.obra?._id || r.obra
                            return String(obraId) === String(obraParaFiltrar)
                        })
                    }

                    // 4. Filtrar por eliminados (si corresponde)
                    if (deleted !== undefined) {
                        filtered = filtered.filter((r) => !!r.deleted === !!deleted)
                    }

                    // 5. Filtrar excluidos
                    filtered = filtered.filter(
                        (r) => !excludedReportIdsRef.current.has(r._id)
                    )

                    // 6. Ordenar
                    if (sortField) {
                        filtered.sort((a, b) => {
                            const valA = a[sortField] || ''
                            const valB = b[sortField] || ''
                            const comparison = String(valA).localeCompare(String(valB))
                            return sortOrder === -1 || sortOrder === 'desc'
                                ? -comparison
                                : comparison
                        })
                    }

                    const totalItems = filtered.length
                    const paginated = filtered.slice(desde, desde + maximo)

                    console.log(
                        `[ReportsContext] Local Offline filter found ${totalItems} items. Slice:`,
                        paginated.length
                    )

                    if (desde === 0) {
                        setExcludedReportIds(new Set())
                        setReportsToShow(paginated)
                    } else {
                        setReportsToShow(paginated)
                    }

                    setTotalReportsList(totalItems)

                    if (deleted) {
                        setTotalItemsInDeleted(totalItems)
                    }

                    if (!deleted) {
                        setDashboardCache((prev) => ({
                            ...prev,
                            [key]: { reportes: paginated, totalItems }
                        }))
                    }
                } catch (err) {
                    console.error(
                        '[ReportsContext] Error in local offline reports pagination:',
                        err
                    )
                } finally {
                    if (fetchId === lastPaginatedFetchIdRef.current) {
                        isFetchingPaginatedRef.current = false
                        setStatusReports(false)
                    }
                }
                return
            }

            if (dashboardCache[key] && !deleted) {
                console.log(
                    `[ReportsContext] Cache hit for ${key}. Serving ${dashboardCache[key].reportes.length} items immediately.`
                )
                const { reportes, totalItems } = dashboardCache[key]
                const filtered = reportes.filter(
                    (r) => !excludedReportIdsRef.current.has(r._id)
                )
                setReportsToShow(filtered)
                setTotalReportsList(totalItems)
                isFetchingPaginatedRef.current = false
            } else {
                setReportsToShow([])
            }

            try {
                const queryEstado =
					estado === 'all' || estado === 'Todos' ? 'todos' : estado
                const { reportes, totalItems } = await ReportsService.reportesPaginados(
                    queryEstado,
                    desde,
                    maximo,
                    obraParaFiltrar,
                    tipoReporte,
                    sortField,
                    sortOrder,
                    deleted
                )

                if (fetchId !== lastPaginatedFetchIdRef.current) {
                    console.log(
                        '[ReportsContext] Discarding paginated reports for stale fetchId:',
                        fetchId
                    )
                    return
                }

                console.log(
                    `[ReportsContext] Received ${reportes.length} reports from service for state: ${estado}`
                )

                if (desde === 0) {
                    setExcludedReportIds(new Set())
                    setReportsToShow(reportes)
                } else {
                    const filtered = reportes.filter(
                        (r) => !excludedReportIdsRef.current.has(r._id)
                    )
                    setReportsToShow(filtered)
                }

                setTotalReportsList(totalItems)

                if (deleted) {
                    setTotalItemsInDeleted(totalItems)
                }

                if (!deleted) {
                    setDashboardCache((prev) => ({
                        ...prev,
                        [key]: { reportes, totalItems }
                    }))
                }
            } catch (error) {
                console.error(
                    `[ReportsContext] Error fetching reports for ${estado}:`,
                    error
                )
            } finally {
                if (fetchId === lastPaginatedFetchIdRef.current) {
                    isFetchingPaginatedRef.current = false
                    setStatusReports(false)
                }
            }
        } else {
            console.log(
                '[ReportsContext] Skipping fetch because no site is selected.'
            )
            isFetchingPaginatedRef.current = false
        }
    }

    const filtroReporte = async (
        estado,
        desde,
        maximo,
        tipoReporte,
        global,
        value,
        tipoDeBusqueda,
        sortField,
        sortOrder
    ) => {
        setStatusReports(true)
        setReportsToShow([])
        try {
            if (siteSelected) {
                let siteIdToSend = 'all'
                if (siteSelected && typeof siteSelected === 'object') {
                    siteIdToSend =
                        siteSelected.idObra === 'none' || siteSelected._id === 'all' || siteSelected._id === 'universal' || siteSelected.idObra === 'universal'
                            ? 'all'
                            : siteSelected._id || siteSelected.idObra
                } else if (siteSelected === 'none' || siteSelected === 'universal') {
                    siteIdToSend = 'all'
                }

                const isGlobal = global === true || String(global) === 'true'
                const queryEstado =
                    isGlobal || estado === 'all' || estado === 'Todos' || !estado ? 'todos' : estado
                const tipoReporteToSend = isGlobal || !tipoReporte ? 'todos' : tipoReporte

                if (!isOnline) {
                    console.log(
                        '[ReportsContext] Offline search (filtroReporte) requested. Searching locally.'
                    )
                    try {
                        const allLocalReports =
                            await ReportsService.getReportsFromIndexedDb()
                        let filtered = allLocalReports || []

                        if (!isGlobal && queryEstado && queryEstado !== 'todos') {
                            filtered = filtered.filter(
                                (r) =>
                                    String(r.state).toLowerCase() ===
                                        String(queryEstado).toLowerCase() ||
                                    String(r.estado).toLowerCase() ===
                                        String(queryEstado).toLowerCase()
                            )
                        }

                        if (siteIdToSend && siteIdToSend !== 'all') {
                            filtered = filtered.filter((r) => {
                                const obraId = r.obra?._id || r.obra
                                return String(obraId) === String(siteIdToSend)
                            })
                        }

                        if (!isGlobal && tipoReporteToSend && tipoReporteToSend !== 'todos') {
                            filtered = filtered.filter(
                                (r) =>
                                    r.reportType === tipoReporteToSend || r.tipoReporte === tipoReporteToSend
                            )
                        }

                        if (value) {
                            const searchVal = String(value).toLowerCase()
                            filtered = filtered.filter((r) => {
                                const otNum = String(r.newIdIndex || r.idIndex || '')
                                const equ = String(r.maquina?.equ || r.maquina || '')
                                const desc = String(r.maquina?.descripcion || '')
                                return (
                                    otNum.includes(searchVal) ||
                                    equ.toLowerCase().includes(searchVal) ||
                                    desc.toLowerCase().includes(searchVal)
                                )
                            })
                        }

                        const totalItems = filtered.length
                        const paginated = filtered.slice(desde, desde + maximo)

                        const filteredToShow = paginated.filter(
                            (r) => !excludedReportIdsRef.current.has(r._id)
                        )
                        setReportsToShow(filteredToShow)

                        return {
                            numeroItems: totalItems
                        }
                    } catch (err) {
                        console.error(
                            '[ReportsContext] Error in local offline reports search:',
                            err
                        )
                        return {
                            numeroItems: 0
                        }
                    }
                }

                const { reportes, numeroItems } =
                    await ReportsService.reportesPaginadosFiltrados(
                        isGlobal ? 'todos' : queryEstado,
                        desde,
                        maximo,
                        siteIdToSend,
                        tipoReporteToSend,
                        isGlobal,
                        value,
                        tipoDeBusqueda,
                        sortField,
                        sortOrder
                    )

                const filtered = reportes.filter(
                    (r) => !excludedReportIdsRef.current.has(r._id)
                )
                setReportsToShow(filtered)
                return {
                    numeroItems: numeroItems
                }
            } else {
                return {
                    numeroItems: null
                }
            }
        } finally {
            setStatusReports(false)
        }
    }

    const checkForOpenReportAndLogout = async () => {
        initiateEndAllShifts(true)
    }

    const provider = {
        reports,
        setReports,
        setOtIndex,
        otIndex,
        assignments,
        assignmentsError,
        listSelected,
        listSelectedCache,
        setListSelected,
        setListSelectedCache,
        loading,
        pautas,
        priorityAssignments,
        normalAssignments,
        saveReport,
        saveReportLocal,
        elevarReporte,
        changeToOrigen,
        getReports,
        getReportsOffline,
        message,
        setMessage,
        statusReports,
        setStatusReports,
        createReport,
        reportsResume,
        setSiteSelected,
        siteSelected,
        guardarContadorEnReporte,
        setReportSelected,
        reportSelected,
        itemProgress,
        setItemProgress,
        borrarListaReportes,
        report,
        setReport,
        numerosEnReportes,
        reportesSeleccionados,
        reportsToShow,
        /* buscarReportesFiltrados, */
        valueFilter,
        setValueFilter,
        tipoReporteSeleccionado,
        setTipoReporteSeleccionado,
        filtroReporte,
        terminarJornada,
        enviarOt,
        cerrarOt,
        ejecutarTerminoJornada,
        progress,
        setProgress,
        pageProgress,
        setPageProgress,
        waitReports,
        refreshNumbers,
        removeReportFromReportsToShow,
        assignReport,
        checkForOpenReportAndLogout,
        initiateEndAllShifts,
        updateLocalReport,
        restoreReport,
        totalItemsInDeleted,
        totalReportsList,
        sortField,
        setSortField,
        sortOrder,
        setSortOrder,
        isDeletedView,
        setIsDeletedView,
        reloadCurrentPage,
        updateNumbersLocally
    }

    return (
        <>
            {openComentarioFinalDialog && (
                <ReportCommitDialog
                    open={openComentarioFinalDialog}
                    closeModal={(data) => {
                        setOpenComentarioFinalDialog(false)
                        if (data) {
                            dataReturned(data)
                        } else {
                            setReportQueue([])
                        }
                    }}
                    terminarjornada={(data) => {
                        dataReturned(data)
                        setOpenComentarioFinalDialog(false)
                    }}
                    isTermJornada={isTerminarJornada}
                    report={report}
                    messageType={messageType}
                />
            )}
            {openBulkFinishDialog && (
                <BulkFinishShiftDialog
                    open={openBulkFinishDialog}
                    reports={reportsToBulkFinish}
                    onFinishReport={handleFinishReportBulk}
                    onClose={(success) => {
                        setOpenBulkFinishDialog(false)
                        if (success && isLogoutPending) {
                            logout(true)
                        } else if (success) {
                            getReports()
                        }
                    }}
                    andLogout={isLogoutPending}
                />
            )}
            <ReportsContext.Provider value={provider} {...props} />
            {/*
                (waitReports && finishReportsProgress) && <div style={{
                    height: 100,
                    width: 300,
                    paddingTop: 10,
                    position: 'absolute', right: 50, bottom: 50, backgroundColor: 'white', border: '1px solid #ccc', borderRadius: 8, padding: 10, textAlign: 'center'}}>
                    <p style={{marginTop: 25}}>
                        Esperando reportes
                    </p>
                </div>
            */}
            {!finishReportsProgress && (
                <div
                    style={{
                        height: 100,
                        width: 300,
                        position: 'absolute',
                        right: 50,
                        bottom: 50,
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: 8,
                        padding: 10
                    }}
                >
                    <LinearProgress
                        color="primary"
                        style={{ margin: '10px 0px' }}
                        variant={'determinate'}
                        value={(reportsProgress.loaded * 100) / reportsProgress.total}
                    />
                    <p>Descargando reportes</p>
                </div>
            )}
        </>
    )
}

export const useReportsContext = () => useContext(ReportsContext)
